<template>
  <div>
    <v-row dense v-for="(subcat, i) in subcategory" :key="i">
      <template v-if="filterByCategory(data, category, subcat).length !== 0">
        <v-col>
          <v-row>
            <v-col cols="12" md="4" sm="4">
              <h4>{{ $t("parameters.subcategory." + subcat) }}</h4>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col :cols="getCols()" :md="getColsMd(item)" :sm="getColsSm(item)" no-gutters v-for="(item, j) in filterByCategory(data, category, subcat)" :key="j">
              <div v-if="isSpaceRequired() === true"></div>
              <div class="font-italic" style="font-size: 8px">
                {{ item.unitName }}
              </div>
              <template v-if="item.view == 'text'">
                <template v-if="'value' in item">
                  <v-text-field v-model="item.value" @change="sendValue(item.unitAddress, item.name, item.value)" type="number" :readonly="getRole(item.unitType)" :label="getLabel(item, item.unitType, '')" :loading="loading" :disabled="disabled"></v-text-field>
                </template>
              </template>

              <template v-else-if="item.view == 'switch'">
                <template v-if="'bits' in item">
                  <v-row>
                    <v-col cols="12" md="2" sm="4" v-for="(bit, k) in item.bits" :key="k">
                      <v-switch dense v-model="bit.value" @change="sendBitValue(item.unitAddress, item.name, bit.name, bit.value)" color="primary" :readonly="getRole(item.unitType)" :label="getLabel(item, item.unitType, bit.name)" :loading="loading" :disabled="disabled"></v-switch>
                    </v-col>
                  </v-row>
                </template>
              </template>

              <template v-else-if="item.view == 'slider'">
                <template v-if="'value' in item">
                  {{ getLabel(item, item.unitType, "") }}
                  <v-slider
                    v-model="item.value"
                    @change="sendValue(item.unitAddress, item.name, item.value)"
                    class="mt-8"
                    :readonly="getRole(item.unitType)"
                    thumb-color="primary"
                    :thumb-size="sliderThumbSize"
                    :min="item.min"
                    :max="item.max"
                    :step="item.max / 100"
                    thumb-label="always"
                    :loading="loading"
                  >
                  </v-slider>
                </template>
              </template>

              <template v-else-if="item.view == 'combobox'">
                <template v-if="'value' in item">
                  <template v-if="item.name == 'Locale'">
                    <v-combobox :readonly="getRole(item.unitType)" v-model="locale" @change="setLocale(item.unitAddress, locale)" :items="locales" :label="$t('settings.localecb')"> </v-combobox>
                  </template>
                  <template v-else-if="item.name == 'Distributor'">
                    <v-combobox :readonly="getRole(item.unitType)" v-model="distributor" @change="setDistributor(item.unitAddress, distributor)" :items="distributors" :label="$t('settings.distributorcb')"></v-combobox>
                  </template>
                  <template v-else> </template>
                </template>
              </template>
              <!-- dualslider -->
              <!-- combox -->
            </v-col>
          </v-row>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { ServiceClient } from "../service_client/index.js";

export default {
  name: "ParametersCoreCategory",
  props: {
    data: {
      type: Array,
      require: true,
    },
    subcategory: {
      type: Array,
      require: true,
    },
    category: {
      type: String,
      require: true,
    },
    locale: {
      type: String,
      require: false,
    },
    distributor: {
      type: String,
      require: false,
    },
  },

  data() {
    return {
      sliderThumbSize: "24",

      loading: false,
      disabled: false,

      user: JSON.parse(sessionStorage.getItem("user")),

      /* locale: [], */
      locales: ["+" + "61" + " " + this.$t("settings.localeCode." + 61), "+" + "64" + " " + this.$t("settings.localeCode." + 64), "+" + "420" + " " + this.$t("settings.localeCode." + 420), "+" + "421" + " " + this.$t("settings.localeCode." + 421)],

      /* distributor: [], */
      distributors: [
        "0)" + " " + this.$t("settings.distributorCode." + 0),
        "1)" + " " + this.$t("settings.distributorCode." + 1),
        "2)" + " " + this.$t("settings.distributorCode." + 2),
        "3)" + " " + this.$t("settings.distributorCode." + 3),
        "4)" + " " + this.$t("settings.distributorCode." + 4),
        "5)" + " " + this.$t("settings.distributorCode." + 5),
        "6)" + " " + this.$t("settings.distributorCode." + 6),
        "7)" + " " + this.$t("settings.distributorCode." + 7),
        "8)" + " " + this.$t("settings.distributorCode." + 8),
        "9)" + " " + this.$t("settings.distributorCode." + 9),
        "10)" + " " + this.$t("settings.distributorCode." + 10),
        "11)" + " " + this.$t("settings.distributorCode." + 11),
        "12)" + " " + this.$t("settings.distributorCode." + 12),
        "13)" + " " + this.$t("settings.distributorCode." + 13),
        "14)" + " " + this.$t("settings.distributorCode." + 14),
        "15)" + " " + this.$t("settings.distributorCode." + 15),
        "16)" + " " + this.$t("settings.distributorCode." + 16),
        "17)" + " " + this.$t("settings.distributorCode." + 17),
        "18)" + " " + this.$t("settings.distributorCode." + 18),
        "19)" + " " + this.$t("settings.distributorCode." + 19),
      ],

      viewCode: ["none", "text", "switch", "slider", "dualslider", "combobox"],
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    isSpaceRequired() {
      return true;
    },
    getCols() {
      return "12";
    },
    getColsMd(item) {
      if (item.view == "switch") {
        return "12";
      } else if (item.view == "text") {
        return "3";
      } else if (item.view == "slider") {
        return "4";
      } else if (item.view == "combobox") {
        return "4";
      } else {
        return "12";
      }
    },
    getColsSm(item) {
      if (item.view == "switch") {
        return "12";
      } else if (item.view == "text") {
        return "6";
      } else if (item.view == "slider") {
        return "12";
      } else if (item.view == "combobox") {
        return "12";
      } else {
        return "12";
      }
    },
    getRole(unitType) {
      if (unitType == "EVCDC01" || unitType == "EVCAC01" || unitType == "EVCAC02" || unitType == "XELMET1") {
        if (this.account.user.roles[1] != "EVC_ADMIN" && this.account.user.roles[1] != "EVC_SERVICE") {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.account.user.roles[0] != "EC_ADMIN") {
          return true;
        } else {
          return false;
        }
      }
    },
    getLabel(item, type, bit) {
      let my = "parameters.";

      let myUnit =
        type == "EINV3H0"
          ? "inverter."
          : type == "EINV1H0"
          ? "inverter." //
          : type == "EINV1H1"
          ? "inverter." //
          : type == "EMPPTH0"
          ? "mppt." //
          : type == "EMPPTH1"
          ? "mppt." //
          : type == "EBCU0H0"
          ? "bcu." //
          : type == "EBATCH0"
          ? "dab." //
          : type == "EDPBMS1"
          ? "bms." //
          : type == "XELMET1"
          ? "meter." //
          : type == "EVCAC02"
          ? "evcac." //
          : type == "EVCAC01"
          ? "evcac." //
          : type == "EVCDC01"
          ? "evcdc." //
          : type == "GDWINV3"
          ? "inverter." //
          : ""; //

      let myBit = bit == "" ? "" : "." + bit;

      let myVarUnit = item.units == "" ? "" : " [" + item.units + "]";

      let l = this.$i18n.t(my + myUnit + item.name + myBit) + myVarUnit;

      return l;
    },
    filterByCategory(array, category, subcategory) {
      let filteredArray = [];

      for (let index = 0; index < array.length; index++) {
        if ("cat" in array[index]) {
          if (array[index].cat == category) {
            if ("subcat" in array[index]) {
              if (array[index].subcat == subcategory) {
                filteredArray.push(array[index]);
              }
            }
          }
        }
      }

      return filteredArray;
    },
    setLocale: function (unitAddress, s) {
      s = s.match(/(\d+)/);
      this.sendValue(unitAddress, "Locale", s[0]);
    },
    setDistributor: function (unitAddress, s) {
      s = s.match(/(\d+)/);
      this.sendValue(unitAddress, "Distributor", s[0]);
    },
    sendValue(unitAddress, variable, value) {
      if (isNaN(value)) {
        return;
      }

      if (value === true) {
        value = 1;
      }
      if (value === false) {
        value = 0;
      }

      let parameters = "?" + "unit" + "=" + unitAddress + "&" + "par" + "=" + variable + "&" + "val" + "=" + value;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, parameters, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
    sendBitValue(unitAddress, unitName, bitName, bitValue) {
      if (isNaN(bitValue)) {
        return;
      }

      if (bitValue === true) {
        bitValue = 1;
      }
      if (bitValue === false) {
        bitValue = 0;
      }

      let parameters = "?" + "unit" + "=" + unitAddress + "&" + "par" + "=" + unitName + "&" + "bit" + "=" + bitName + "&" + "val" + "=" + bitValue;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, parameters, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
  },
  destroyed() {},
};
</script>

<style scoped></style>
